module.exports = __webpack_public_path__ + "static/media/vehicle_not_available.8de90a1f.jpg";